import { ReactElement, useId } from 'react';
import { LoadingGradient } from '@provider-directory/components/loading-gradient/loading-gradient.component';
import { ProviderSearchResultsSkeleton } from '@provider-directory/components/search-results-skeleton/search-results-skeleton.component';

const ProviderSearchSkeleton = (): ReactElement => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={
        'outer-margin pb-3 pt-6 tablet:pb-24 tablet:pt-8 desktop:pb-24 desktop:pt-11'
      }
    >
      <h2 id={headingId} className={'sr-only'}>
        Providers
      </h2>
      <div className={'grid grid-cols-2 gap-4 desktop:grid-cols-12'}>
        <div className={'pb-2 text-body-medium-semibold desktop:col-span-4'}>
          <LoadingGradient className={'h-[24px] w-[130px] rounded-lg'} />
        </div>
        <div
          className={
            'justify-items-end desktop:col-span-4 desktop:justify-items-start'
          }
        >
          <LoadingGradient className={'h-[24px] w-[170px] rounded-lg'} />
        </div>
        <div className={'hidden justify-end desktop:col-span-4 desktop:flex'}>
          <LoadingGradient className={'h-[24px] w-[315px] rounded-lg'} />
        </div>
        {/* Filters */}
        <div className={'hidden desktop:col-span-4 desktop:block'}>
          <LoadingGradient className={'h-[1300px] w-full rounded-lg'} />
        </div>
        {/* Provider list */}
        <div className={'col-span-2 desktop:col-span-8'}>
          <ProviderSearchResultsSkeleton />
        </div>
      </div>
    </section>
  );
};

export default ProviderSearchSkeleton;
